import { render, staticRenderFns } from "./ScoreStampPreviewBox.vue?vue&type=template&id=2988cb21&scoped=true&"
import script from "./ScoreStampPreviewBox.vue?vue&type=script&lang=ts&"
export * from "./ScoreStampPreviewBox.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreStampPreviewBox.vue?vue&type=style&index=0&id=2988cb21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988cb21",
  null
  
)

export default component.exports